import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-5" }
const _hoisted_2 = { class: "flex flex-col items-center mb-3" }
const _hoisted_3 = { class: "basis-1/2" }
const _hoisted_4 = { class: "text-3xl font-bold text-center" }
const _hoisted_5 = { class: "flex justify-center pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    visible: _ctx.visibleAttivo,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visibleAttivo) = $event))
  }, {
    header: _withCtx(() => _cache[2] || (_cache[2] = [
      _createElementVNode("div", null, null, -1)
    ])),
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-center" }, "L'alert manuale è ora attivo il giorno", -1)),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.date), 1),
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-center" }, "ed assegnato a", -1))
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_NextButton, {
          variant: "outline-secondary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:visibleAttivo', false))),
          class: "col-start-3 py-2 px-4"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode(" Chiudi ")
          ])),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}